<template>
  <div
    :class="`${
      $store.state.auth.settings.attributables.LISAPAY === 'Y'
        ? ''
        : 'tag-lisapay--hidden'
    }`"
    :data-editor-id="editor_id"
  >
    <editor ref="tiny" :api-key="apikey" :init="config" v-model="inputVal" />
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  data() {
    return {
      apikey: process.env.VUE_APP_TINYMCE_API_KEY,
      config: {
        language: "it",
        toolbar:
          "fullscreen | undo redo | blocks | fontfamily | fontsize | bold italic underline forecolor | alignleft aligncenter alignright alignjustify | lineheight | bullist numlist outdent indent | removeformat | tags | image | pagebreak | table | code",
        plugins:
          "lists link image charmap table visualblocks code fullscreen table pagebreak",
        font_family_formats:
          "Arial=arial,sans-serif; Bookman Old Style=bookman old style,serif; Garamond=garamond,serif; Helvetica=helvetica,sans-serif;",
        font_size_formats: "8px 10px 12px 14px 16px 18px 24px 36px 48px",
        tag_type: null,
        image_list: [],
        table_row_class_list: [
          { title: "None", value: "" },
          { title: "Riga ripetuta", value: "repeatRow" },
        ],
        pagebreak_separator:
          '<div style="page-break-after: always;">&nbsp;</div>',
        setup: function (editor) {
          editor.ui.registry.addMenuButton("tags", {
            text: "Tags",
            fetch: (callback) => {
              const items = [
                {
                  type: "menuitem",
                  text: "Data Odierna Estesa",
                  onAction: () => editor.insertContent("[[DATA_ODIERNA_LONG]]"),
                },
                {
                  type: "menuitem",
                  text: "Data Odierna ",
                  onAction: () =>
                    editor.insertContent("[[DATA_ODIERNA_SHORT]]"),
                },
                {
                  type: "nestedmenuitem",
                  text: "Destinatario",
                  getSubmenuItems: function () {
                    return [
                      {
                        type: "menuitem",
                        text: "Denominazione",
                        onAction: () =>
                          editor.insertContent(
                            "[[NOME]] [[COGNOME]][[RAGIONE_SOCIALE]]",
                          ),
                      },
                      {
                        type: "menuitem",
                        text: "Nome",
                        onAction: () => editor.insertContent("[[NOME]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Cognome",
                        onAction: () => editor.insertContent("[[COGNOME]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Ragione Sociale",
                        onAction: () =>
                          editor.insertContent("[[RAGIONE_SOCIALE]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Ragione Sociale alternativa",
                        onAction: () =>
                          editor.insertContent(
                            "[[RAGIONE_SOCIALE_ALTERNATIVA]]",
                          ),
                      },
                      {
                        type: "menuitem",
                        text: "PIVA",
                        onAction: () => editor.insertContent("[[PIVA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Codice Fiscale",
                        onAction: () => editor.insertContent("[[CF]]"),
                      },
                      {
                        type: "nestedmenuitem",
                        text: "Contatti",
                        getSubmenuItems: function () {
                          return [
                            {
                              type: "menuitem",
                              text: "Telefono",
                              onAction: () =>
                                editor.insertContent("[[TEL_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Cellulare",
                              onAction: () =>
                                editor.insertContent("[[CELL_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Email",
                              onAction: () =>
                                editor.insertContent("[[EMAIL_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Pec",
                              onAction: () =>
                                editor.insertContent("[[PEC_MAIN]]"),
                            },
                          ];
                        },
                      },
                      {
                        type: "nestedmenuitem",
                        text: "Indirizzo Principale",
                        getSubmenuItems: function () {
                          return [
                            {
                              type: "menuitem",
                              text: "Indirizzo",
                              onAction: () =>
                                editor.insertContent("[[INDIRIZZO_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Cap",
                              onAction: () =>
                                editor.insertContent("[[CAP_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Comune",
                              onAction: () =>
                                editor.insertContent("[[COMUNE_MAIN]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Provincia",
                              onAction: () =>
                                editor.insertContent("[[PROVINCIA_MAIN]]"),
                            },
                          ];
                        },
                      },
                      {
                        type: "nestedmenuitem",
                        text: "Indirizzo Corrispondenza",
                        getSubmenuItems: function () {
                          return [
                            {
                              type: "menuitem",
                              text: "Indirizzo",
                              onAction: () =>
                                editor.insertContent("[[INDIRIZZO_CORR]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Cap",
                              onAction: () =>
                                editor.insertContent("[[CAP_CORR]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Comune",
                              onAction: () =>
                                editor.insertContent("[[COMUNE_CORR]]"),
                            },
                            {
                              type: "menuitem",
                              text: "Provincia",
                              onAction: () =>
                                editor.insertContent("[[PROVINCIA_CORR]]"),
                            },
                          ];
                        },
                      },
                      {
                        type: "menuitem",
                        text: "LISAPAY",
                        onAction: () => editor.insertContent("[[PAY_LISAPAY]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Lista polizze",
                        onAction: () =>
                          editor.insertContent("[[LISTA_POLIZZE]]"),
                      },
                    ];
                  },
                },
                {
                  type: "nestedmenuitem",
                  text: "Righe",
                  getSubmenuItems: function () {
                    return [
                      {
                        type: "menuitem",
                        text: "Data",
                        onAction: () => editor.insertContent("[[DATA_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Nominativo Contraente",
                        onAction: () =>
                          editor.insertContent(
                            "[[NOMINATIVO_CONTRAENTE_RIGA]]",
                          ),
                      },
                      {
                        type: "menuitem",
                        text: "Compagnia (Codice)",
                        onAction: () =>
                          editor.insertContent("[[COMPAGNIA_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Compagnia (Nome)",
                        onAction: () =>
                          editor.insertContent("[[COMPAGNIA_NOME_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Numero Polizza",
                        onAction: () =>
                          editor.insertContent("[[NUMERO_POLIZZA_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Ramo",
                        onAction: () => editor.insertContent("[[RAMO_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Prodotto",
                        onAction: () => editor.insertContent("[[PRODOTTO]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Netto",
                        onAction: () => editor.insertContent("[[NETTO_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Tasse",
                        onAction: () => editor.insertContent("[[TASSE_RIGA]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Lordo",
                        onAction: () => editor.insertContent("[[LORDO_RIGA]]"),
                      },
                    ];
                  },
                },
                {
                  type: "nestedmenuitem",
                  text: "Totale Righe",
                  getSubmenuItems: function () {
                    return [
                      {
                        type: "menuitem",
                        text: "Netto",
                        onAction: () => editor.insertContent("[[TOT_NETTO]]"),
                      },
                      {
                        type: "menuitem",
                        text: "Lordo",
                        onAction: () => editor.insertContent("[[TOT_LORDO]]"),
                      },
                    ];
                  },
                },
                {
                  type: "menuitem",
                  text: "Note",
                  onAction: () => editor.insertContent("[[NOTE]]"),
                },
                {
                  type: "menuitem",
                  text: "Paga con Lisapay",
                  onAction: () => editor.insertContent("[[PAY_LISAPAY]]"),
                },
                {
                  type: "menuitem",
                  text: "Lista polizze",
                  onAction: () => editor.insertContent("[[LISTA_POLIZZE]]"),
                },
              ];
              callback(items);
            },
          });
        },
        menubar: false,
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px} .repeatRow {background-color: #dedede}",
        branding: false,
      },
      tinyEditor: null,
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      console.log(`Prop "value" changed: , ${newVal}, | was: , ${oldVal}`);
      const ed =
        this.$refs.tiny && this.$refs.tiny.getEditor
          ? this.$refs.tiny.getEditor()
          : null;
      if (ed) {
        this.tinyEditor = ed;
        ed.setContent(this.value || "");
        // ed.tinyEditor.insertContent(this.value || "");
      }
    },
  },
  props: {
    editor_id: null,
    value: null,
    height: {
      type: Number,
      default: 100,
    },
    tag_type: {
      type: String,
      default: "",
    },
    image_list: {
      type: Array,
      default() {
        return [];
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    editor: Editor,
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    getType() {
      return this.tag_type;
    },
  },
  created() {
    this.$set(this.config, "height", this.height);
    this.$set(this.config, "image_list", this.image_list);
    const vm = this;
    this.config.setup = (editor) => {
      // qui si può usare vm (Vue) e editor (TinyMCE)
      editor.ui.registry.addMenuButton("tags", {
        text: "Tags",
        fetch: (callback) => {
          const items = [
            {
              type: "menuitem",
              text: "Data Odierna Estesa",
              onAction: () => editor.insertContent("[[DATA_ODIERNA_LONG]]"),
            },
            {
              type: "menuitem",
              text: "Data Odierna ",
              onAction: () => editor.insertContent("[[DATA_ODIERNA_SHORT]]"),
            },
            {
              type: "nestedmenuitem",
              text: "Destinatario",
              getSubmenuItems: function () {
                return [
                  {
                    type: "menuitem",
                    text: "Denominazione",
                    onAction: () =>
                      editor.insertContent(
                        "[[NOME]] [[COGNOME]][[RAGIONE_SOCIALE]]",
                      ),
                  },
                  {
                    type: "menuitem",
                    text: "Nome",
                    onAction: () => editor.insertContent("[[NOME]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Cognome",
                    onAction: () => editor.insertContent("[[COGNOME]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Ragione Sociale",
                    onAction: () => editor.insertContent("[[RAGIONE_SOCIALE]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Ragione Sociale alternativa",
                    onAction: () =>
                      editor.insertContent("[[RAGIONE_SOCIALE_ALTERNATIVA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "PIVA",
                    onAction: () => editor.insertContent("[[PIVA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Codice Fiscale",
                    onAction: () => editor.insertContent("[[CF]]"),
                  },
                  {
                    type: "nestedmenuitem",
                    text: "Contatti",
                    getSubmenuItems: function () {
                      return [
                        {
                          type: "menuitem",
                          text: "Telefono",
                          onAction: () => editor.insertContent("[[TEL_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Cellulare",
                          onAction: () => editor.insertContent("[[CELL_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Email",
                          onAction: () =>
                            editor.insertContent("[[EMAIL_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Pec",
                          onAction: () => editor.insertContent("[[PEC_MAIN]]"),
                        },
                      ];
                    },
                  },
                  {
                    type: "nestedmenuitem",
                    text: "Indirizzo Principale",
                    getSubmenuItems: function () {
                      return [
                        {
                          type: "menuitem",
                          text: "Indirizzo",
                          onAction: () =>
                            editor.insertContent("[[INDIRIZZO_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Cap",
                          onAction: () => editor.insertContent("[[CAP_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Comune",
                          onAction: () =>
                            editor.insertContent("[[COMUNE_MAIN]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Provincia",
                          onAction: () =>
                            editor.insertContent("[[PROVINCIA_MAIN]]"),
                        },
                      ];
                    },
                  },
                  {
                    type: "nestedmenuitem",
                    text: "Indirizzo Corrispondenza",
                    getSubmenuItems: function () {
                      return [
                        {
                          type: "menuitem",
                          text: "Indirizzo",
                          onAction: () =>
                            editor.insertContent("[[INDIRIZZO_CORR]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Cap",
                          onAction: () => editor.insertContent("[[CAP_CORR]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Comune",
                          onAction: () =>
                            editor.insertContent("[[COMUNE_CORR]]"),
                        },
                        {
                          type: "menuitem",
                          text: "Provincia",
                          onAction: () =>
                            editor.insertContent("[[PROVINCIA_CORR]]"),
                        },
                      ];
                    },
                  },
                  {
                    type: "menuitem",
                    text: "Lista polizze",
                    onAction: () => editor.insertContent("[[LISTA_POLIZZE]]"),
                  },
                ];
              },
            },
            {
              type: "nestedmenuitem",
              text: "Righe",
              getSubmenuItems: function () {
                return [
                  {
                    type: "menuitem",
                    text: "Data",
                    onAction: () => editor.insertContent("[[DATA_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Nominativo Contraente",
                    onAction: () =>
                      editor.insertContent("[[NOMINATIVO_CONTRAENTE_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Compagnia (Codice)",
                    onAction: () => editor.insertContent("[[COMPAGNIA_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Compagnia (Nome)",
                    onAction: () =>
                      editor.insertContent("[[COMPAGNIA_NOME_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Numero Polizza",
                    onAction: () =>
                      editor.insertContent("[[NUMERO_POLIZZA_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Ramo",
                    onAction: () => editor.insertContent("[[RAMO_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Prodotto",
                    onAction: () => editor.insertContent("[[PRODOTTO]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Netto",
                    onAction: () => editor.insertContent("[[NETTO_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Tasse",
                    onAction: () => editor.insertContent("[[TASSE_RIGA]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Lordo",
                    onAction: () => editor.insertContent("[[LORDO_RIGA]]"),
                  },
                ];
              },
            },
            {
              type: "nestedmenuitem",
              text: "Totale Righe",
              getSubmenuItems: function () {
                return [
                  {
                    type: "menuitem",
                    text: "Netto",
                    onAction: () => editor.insertContent("[[TOT_NETTO]]"),
                  },
                  {
                    type: "menuitem",
                    text: "Lordo",
                    onAction: () => editor.insertContent("[[TOT_LORDO]]"),
                  },
                ];
              },
            },
            {
              type: "menuitem",
              text: "Note",
              onAction: () => editor.insertContent("[[NOTE]]"),
            },
            {
              type: "menuitem",
              text: "Paga con Lisapay",
              onAction: () => editor.insertContent("[[PAY_LISAPAY]]"),
            },
            {
              type: "menuitem",
              text: "Lista polizze",
              onAction: () => editor.insertContent("[[LISTA_POLIZZE]]"),
            },
          ];
          callback(items);
        },
      });
      editor.on("SelectionChange", () => {
        // vm.value, vm.$refs, vm.$emit...
        console.log("vm", vm);
        console.log("editor", editor);
        const content = editor.getBody().innerHTML;
        if (content) {
          this.$emit("updateEditorContent", content);
        }
      });
    };
  },
  mounted() {
    if (this.isEdit) {
      setTimeout(() => {
        this.$nextTick(() => {
          const ed =
            this.$refs.tiny && this.$refs.tiny.getEditor
              ? this.$refs.tiny.getEditor()
              : null;

          if (ed) {
            this.tinyEditor = ed;
            this.$emit("onInitEditEditor");
          }
        });
      }, 1000);
    }
  },
};
</script>
<style lang="css">
body:has(.tag-lisapay--hidden) div[title="Paga con Lisapay"] {
  display: none;
  pointer-events: none;
  touch-action: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
<style scoped>
.base-label:focus {
  outline: none !important;
}
</style>
